import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface WidgetState {
	activeWidget: { id: number };
	state: boolean;
	availableWidgets: [];
	userWidgets: [];
	/** Incremented when Feed (id 0) is selected — gates TF on web until explicit Feed tab use. */
	feedEngagementToken: number;
}

const initialState = {
	activeWidget: { id: 0 },
	state: true,
	availableWidgets: [],
	userWidgets: [],
	feedEngagementToken: 0,
} as WidgetState;

const widgetSlice = createSlice({
	name: 'homeWidgets',
	initialState,
	reducers: {
		changeWidget(state, action) {
			console.log('🔄 [widgetReducer] changeWidget called', {
				payload: action.payload,
				currentId: state.activeWidget.id,
				currentState: state.state,
			});
			state.activeWidget = {
				id: action.payload.id,
			};
			if (action.payload.id === 0) {
				state.feedEngagementToken += 1;
			}
			// Ensure state remains true when changing widgets
			if (state.state !== true) {
				console.log(
					'⚠️ [widgetReducer] State was false, setting to true'
				);
				state.state = true;
			}
			console.log('✅ [widgetReducer] Widget changed', {
				newId: state.activeWidget.id,
				state: state.state,
			});
		},
	},
});

export const { changeWidget } = widgetSlice.actions;

export default widgetSlice.reducer;
